import type { Action } from '@reduxjs/toolkit';
import { combineReducers } from '@reduxjs/toolkit';

import { slice as snackbarSlice } from './modules/common/redux/slices/snackbar';
import { slice as teamShareSlice } from './modules/common/redux/slices/teamShare';
import { slice as channelSlice } from './modules/PlayerOverview/redux/slices/additional';
import { slice as chaptersSlice } from './modules/PlayerOverview/redux/slices/chapters';
import { slice as commentsSlice } from './modules/PlayerOverview/redux/slices/comments';
import { slice as channelCommonSlice } from './modules/PlayerOverview/redux/slices/common';
import { slice as channelShareSlice } from './modules/PlayerOverview/redux/slices/share';
import { slice as singleShareSlice } from './modules/PlayerOverview/redux/slices/single';
import { slice as slidesSlice } from './modules/PlayerOverview/redux/slices/slides';
import { slice as transcriptsSlice } from './modules/PlayerOverview/redux/slices/transcripts';
import { slice as autocompleteSearchSlice } from './modules/Search/redux/slices/autocomplete';
import { slice as deepSearchSlice } from './modules/Search/redux/slices/deepSearch';
import { slice as searchSlice } from './modules/Search/redux/slices/search';
import { slice as searchAiSlice } from './modules/Search/redux/slices/searchAi';
import { resetStoreAction, slice as commonSlice } from '@/modules/common/redux/slices/common';
import { slice as additionalSlice } from '@/modules/common/redux/slices/guestShare';
import { slice as i18nSlice } from '@/modules/common/redux/slices/i18n';

const rootReducer = combineReducers({
  [additionalSlice.name]: additionalSlice.reducer,
  [autocompleteSearchSlice.name]: autocompleteSearchSlice.reducer,
  [channelCommonSlice.name]: channelCommonSlice.reducer,
  [channelShareSlice.name]: channelShareSlice.reducer,
  [channelSlice.name]: channelSlice.reducer,
  [chaptersSlice.name]: chaptersSlice.reducer,
  [commentsSlice.name]: commentsSlice.reducer,
  [commonSlice.name]: commonSlice.reducer,
  [deepSearchSlice.name]: deepSearchSlice.reducer,
  [searchAiSlice.name]: searchAiSlice.reducer,
  [searchSlice.name]: searchSlice.reducer,
  [singleShareSlice.name]: singleShareSlice.reducer,
  [slidesSlice.name]: slidesSlice.reducer,
  [snackbarSlice.name]: snackbarSlice.reducer,
  [teamShareSlice.name]: teamShareSlice.reducer,
  [transcriptsSlice.name]: transcriptsSlice.reducer,
  [i18nSlice.name]: i18nSlice.reducer,
});

type RootState = ReturnType<typeof rootReducer>;

export default (state: RootState | undefined, action: Action) =>
  rootReducer(action.type === resetStoreAction.type ? undefined : state, action);
